import React, { useEffect, useState } from 'react';

import { ProceedWrapper } from './style';
import { isEmpty } from '../../utils/common';
import ModalData from '../ModalData/ModalData';
import animationData1 from "../../assets/lotties/question.json";
import { getProcessFund } from '../../utils/api';

export default function Proceed({ item, getListing=()=>{}, className="",setMessage=()=>{}  }) {

    const [loader, setLoader] = useState(false);
    const [confirm, setConfirm] = useState(false);

  
    const defaultOptions1 = {
        loop: true,
        autoplay: true,
        animationData: animationData1,
      };

        const processData = () =>{
            setLoader(true);
            setConfirm(false)
            getProcessFund(item?.fileId).then(resp => {
                setLoader(false);
                if(resp?.data?.success) {
                    const msg = resp?.data?.msg;
                    setMessage({ type: "success", msg: msg });
                    getListing(0);
                }else{
                    const msg = resp?.data?.msg;
                    if (resp?.data?.errorCodeList?.length) {
                      msg = resp?.errorCodeLis.toString();
                    }
                    
                    setMessage({ type: "error", msg: msg });
                }
             
            })
        }

        

    return(
        <>
        <ProceedWrapper className={className}>
            <button className="update-wallet-btn" onClick={() =>setConfirm(true) } disabled={loader}>Proceed</button>
           
        </ProceedWrapper>
        {!isEmpty(confirm) && (
                        <ModalData
                          onClickCancel={() => setConfirm(false)}
                          onClickConfirm={() => processData()}
                          lottieOptions={defaultOptions1}
                          heading1="You want to Proceed ?"
                        />
                      )}
        </>
    )
}
